window.addEventListener('load', event => {
	let loader = document.querySelector('.js-loader');
  if (loader) loader.classList.add('is-faded');
});
